<template>
  <div class="pa-6">
    <div class="d-flex align-center">
      <h1 class="mb-4">Summary</h1>
      <v-btn
        v-if="!$store.getters.isGuest"
        @click="generateSummary"
        class="ml-4"
        variant="tonal"
        ><v-icon>mdi-creation</v-icon></v-btn
      >
    </div>
    <div v-if="project && project.summary">
      <p style="font-size: 10pt">Summary title:</p>
      <v-text-field v-model="project.summary.title"></v-text-field>
      <p style="font-size: 10pt">Summary paragraphs:</p>
      <div v-for="(s, i) in project.summary.summaries" :key="i">
        <v-text-field variant="solo" v-model="s.title"></v-text-field>
        <v-textarea variant="solo" v-model="s.text"> </v-textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { functions } from "@/firebase";
import { httpsCallable } from "firebase/functions";
import { mapState } from "vuex";

export default {
  data() {
    return {
      language: "Dutch",
    };
  },
  computed: {
    ...mapState({
      projects: (state) => state.projects,
      project: (state) => state.project,
    }),
  },
  methods: {
    async generateSummary() {
      this.$store.commit("setLoading", true);
      console.log("Generating executive summary");
      const generateSummary = httpsCallable(functions, "generateSummary");

      const res = await generateSummary({
        chapters: this.project.chapters,
        language: this.language,
      });
      console.log(res.data);
      this.project.summary = res.data;
      this.$store.commit("setLoading", false);
    },
  },
};
</script>
